import React, {Component} from 'react';
import ReactDOM from 'react-dom';
import { Button } from '../../components/buttons';
import { Layout, MinMaxLayout, SeventyThirtyLayout, SixtyFourtyLayout } from '../../layouts';
import Welcome from '../../layouts/welcome';
import Row from '../../components/row';
import Container from '../../layouts/containers/container';
import ActivityItemNew from '../../components/activity/activity-item-new';
import List from '../../components/list';
import PopupContext from '../../context/context-popup';
import PopupsOnboarding from './popups/popups-onboarding';
import Scrollable from '../../components/scrollable';
import ContainerTable from '../../layouts/containers/container-table';
import meApi from '../../lib/users/me-api';
import { SmallPill } from '../../components/pills';
import {nowUTCTimeStamp, stringToFriendlyDatetime} from '../../lib/helpers/datetime-helpers';
import Grid from '../../components/grid';
import Eye from '../../components/buttons/eye';
import Arrow from '../../components/buttons/arrow';
import dayjs from 'dayjs';
import CompaniesApi from '../../lib/companies/companies-api';
import Auth from '../../lib/users/auth';
import LatestUpdates from "./components/component-latest-updates";
import EmptyState from '../../components/states/empty';
import RenderThisIf from '../../components/renderIf';
import auth from '../../lib/users/auth';
import { COMPANY_BOOK_CO_WORKING_SPACES, COMPANY_BOOK_EVENTS, COMPANY_BOOK_MEETING_ROOMS } from '../../utils/permissions';

const types = {
  "App\\Models\\MeetingRoomBooking": "Meeting",
  "App\\Models\\EventBooking": "Event",
  "App\\Models\\EventAttendee": "Event",
  "App\\Models\\CoWorkingBooking": "Co-Working",
  "App\\Models\\MeetingAttendee": "Meeting",
};

class CompanyBookings extends Component {
  constructor(props) {
    super(props);

    this.state = {
      bookings: null,
    };
  }

  componentDidMount() {
    this.getBookings();
  }

  getBookings() {
    this.setState({ bookings: null });

    CompaniesApi.upcomingBookings(Auth.user.company.id).then(({ data }) => {
        this.setState({ bookings: data })
    });
  }

  getBookingsTableData() {
    let data = [];

    if (this.state.bookings?.length > 0) {
      this.state.bookings?.forEach((booking) => {

        const link = this.getLink(booking);

        data.push([booking, types?.[booking?.type] || "None", link]);
      });
    }

    return data;
  }
  getLink(booking) {
    const base = {
      "App\\Models\\MeetingRoomBooking": "bookings",
      "App\\Models\\EventBooking": "events",
      "App\\Models\\EventAttendee": "events",
      "App\\Models\\CoWorkingBooking": "co-working/bookings",
      "App\\Models\\MeetingAttendee": "bookings",
    };

    const type = base?.[booking?.type];

    let url = `/mydmc/${type || ""}/${booking.id}`;

    if (type === 'events') {
      url = `/mydmc/events/${booking?.event_id}/bookings/${booking.id}`;
    }

    return url;
  }

  render() {
    return (
      <Container.Content>
        <ContainerTable
          isEmpty={this.state.bookings?.length === 0 || this.state.bookings === null}
          ifEmpty={
            <EmptyState
              loading={this.state.bookings === null}
              title="Bookings"
              description="There does not seem to be any results"
              titleColor='#FF5F26'
              descriptionColor='black'
              style={{ minHeight: '300px' }}
            />
          }
          columns={[
            { field: "Booking Details", width: "50%" },
            { field: "Type", width: "20%" },
            { field: "View Booking", width: "15%" },
          ]}
          data={[...this.getBookingsTableData()]}
          replaceColumn={{
            0: (data) => {
              return (
                <List gap="10px">
                  <Container.Text fontSize="16px" color="#354859">
                    {data?.name ||
                      data?.meeting_room?.name ||
                      data?.meeting_room_booking?.name ||
                      data?.co_working_space?.name ||
                      data?.event?.name}
                  </Container.Text>
                  <Container.Text fontSize="14px" color="#929BA8">
                    <Row gap="10px">
                      <Container.Text color="#FF6933">
                        {data?.id}
                      </Container.Text>{" "}
                      | Starts:{" "}
                      {stringToFriendlyDatetime(data?.event?.start || data?.day || data?.start)} |{" "}
                      {stringToFriendlyDatetime(data?.created_at)}
                    </Row>
                  </Container.Text>
                </List>
              );
            },
            2: (data) => {
              return (
                <svg
                  onClick={() => (window.location.href = data)}
                  style={{
                    cursor: "pointer",
                    rotate: "-90deg",
                    marginLeft: "40px",
                  }}
                  xmlns="http://www.w3.org/2000/svg"
                  width="17.702"
                  height="18.349"
                  viewBox="0 0 17.702 18.349"
                >
                  <path
                    id="Path_57"
                    data-name="Path 57"
                    d="M14.211,17.959l6.1-6.151,1.609,1.622-8.851,8.92-8.851-8.92,1.609-1.622,6.1,6.151V4h2.276Z"
                    transform="translate(-4.222 -4)"
                    fill="#cecece"
                  />
                </svg>
              );
            },
          }}
        />
      </Container.Content>
    );
  }
}

class MyBookings extends Component {
  constructor() {
    super();

    this.state = {
      bookings: null,
      currentPage: 1,
    };
  }

  componentDidMount() {
    this.getBookings();
  }

  getBookings() {
    meApi.upcomingBookings().then(({ data }) => {
      this.setState({ bookings: data });
    });
  }

  getLink(booking) {
    const base = {
      "App\\Models\\MeetingRoomBooking": "bookings",
      "App\\Models\\EventBooking": "events",
      "App\\Models\\EventAttendee": "events",
      "App\\Models\\CoWorkingBooking": "co-working/bookings",
      "App\\Models\\MeetingAttendee": "bookings",
    };

    const type = base?.[booking?.type];

    let url = `/mydmc/${type || ""}/${booking.id}`;

    if (type === 'events') {
      url = `/mydmc/events/${booking?.event_id}/bookings/${booking.id}`;
    }

    return url;
  }

  getBookingsTableData() {
    let data = [];

    if (this.state.bookings?.length > 0) {
      this.state.bookings?.forEach((booking) => {

        const link = this.getLink(booking);

        data.push([booking, types?.[booking?.type] || "None", link]);
      });
    }

    return data;
  }

  render() {
    return (
      <Container.Content>
        <ContainerTable
          isEmpty={this.state.bookings?.length === 0 || this.state.bookings === null}
          ifEmpty={
            <EmptyState
              loading={this.state.bookings === null}
              title="Bookings"
              description="There does not seem to be any results"
              titleColor='#FF5F26'
              descriptionColor='black'
              style={{ minHeight: '300px' }}
            />
          }
          columns={[
            { field: "Booking Details", width: "50%" },
            { field: "Type", width: "20%" },
            { field: "View Booking", width: "15%" },
          ]}
          data={[...this.getBookingsTableData()]}
          replaceColumn={{
            0: (data) => {
              return (
                <List gap="10px">
                  <Container.Text fontSize="16px" color="#354859">
                    {data?.name ||
                      data?.meeting_room?.name ||
                      data?.meeting_room_booking?.name ||
                      data?.co_working_space?.name ||
                      data?.event?.name}
                  </Container.Text>
                  <Container.Text fontSize="14px" color="#929BA8">
                    <Row gap="10px">
                      <Container.Text color="#FF6933">
                        {data?.id}
                      </Container.Text>{" "}
                      | Starts:{" "}
                      {stringToFriendlyDatetime(data?.event?.start || data?.day || data?.start)} |{" "}
                      {stringToFriendlyDatetime(data?.created_at)}
                    </Row>
                  </Container.Text>
                </List>
              );
            },
            2: (data) => {
              return (
                <svg
                  onClick={() => (window.location.href = data)}
                  style={{
                    cursor: "pointer",
                    rotate: "-90deg",
                    marginLeft: "40px",
                  }}
                  xmlns="http://www.w3.org/2000/svg"
                  width="17.702"
                  height="18.349"
                  viewBox="0 0 17.702 18.349"
                >
                  <path
                    id="Path_57"
                    data-name="Path 57"
                    d="M14.211,17.959l6.1-6.151,1.609,1.622-8.851,8.92-8.851-8.92,1.609-1.622,6.1,6.151V4h2.276Z"
                    transform="translate(-4.222 -4)"
                    fill="#cecece"
                  />
                </svg>
              );
            },
          }}
        />
      </Container.Content>
    );
  }
}

class Dashboard extends Component {
  static contextType = PopupContext;

  constructor(props) {
    super(props);

    this.state = {
      tab: 0,
    };
  }

  isOwnerOrManager() {
    return (
      window.user?.roles?.find(({ name }) => name === "Owner") ||
      window.user?.roles?.find(({ name }) => name === "Manager")
    );
  }

  render() {
    return (
      <List gap="40px">
        <Container>
          <Container.Header>
            <Row gap="20px" justifyContent="space-between" alignItems="center" wrap>
              <Container.Text fontSize="18px" fontWeight="500" color="#FF6933">
                My Upcoming Bookings
              </Container.Text>

              <Row gap="10px" alignItems="center">
                <SmallPill
                  onClick={() => this.setState({ tab: 0 })}
                  state={this.state.tab === 0 && "highlighted"}
                >
                  Me
                </SmallPill>
                {this.isOwnerOrManager() && (
                  <SmallPill
                    onClick={() => this.setState({ tab: 1 })}
                    state={this.state.tab === 1 && "highlighted"}
                  >
                    My Team
                  </SmallPill>
                )}
              </Row>
            </Row>
          </Container.Header>

          {this.state.tab === 0 && <MyBookings />}
          {this.state.tab === 1 && <CompanyBookings />}
        </Container>

        <Container>
          <Container.Header>
            <Container.Text fontSize="18px" fontWeight="500" color="#FF6933">
              Quick Links
            </Container.Text>
          </Container.Header>

          <Container.Content>
            <Grid columns={2} gap="30px" className="grid-column-2">
              <RenderThisIf
                renderIf={auth.hasPermission(COMPANY_BOOK_MEETING_ROOMS) || auth.isOwnerOrManager()}
                render={
                  <div className="quick-link">
                    <h3>Need a meeting room?</h3>
                    <Button
                      transparent
                      leftIcon={<Eye />}
                      rightIcon={<Arrow rotate="-90deg" />}
                      href="/mydmc/meeting-rooms"
                    >
                      Book
                    </Button>
                </div>
                }
              />

              <RenderThisIf
                renderIf={auth.hasPermission(COMPANY_BOOK_CO_WORKING_SPACES) || auth.isOwnerOrManager()}
                render={
                  <div className="quick-link quick-link--coworking">
                    <h3>Looking For Co-Working?</h3>
                    <Button
                      transparent
                      leftIcon={<Eye />}
                      rightIcon={<Arrow rotate="-90deg" />}
                      href="/mydmc/co-working"
                    >
                      Book
                    </Button>
                  </div>
                }
              />

              <RenderThisIf
                renderIf={auth.hasPermission(COMPANY_BOOK_EVENTS) || auth.isOwnerOrManager()}
                render={
                  <div className="quick-link quick-link--events">
                    <h3>Interested In Events?</h3>
                    <Button
                      transparent
                      leftIcon={<Eye />}
                      rightIcon={<Arrow rotate="-90deg" />}
                      href="/mydmc/events"
                    >
                      Book
                    </Button>
                  </div>
                }
              />

              <div className="quick-link quick-link--support">
                <h3>Need Business Support?</h3>
                <Button
                  transparent
                  leftIcon={<Eye />}
                  rightIcon={<Arrow rotate="-90deg" />}
                  href="/mydmc/help"
                >
                  Book
                </Button>
              </div>
            </Grid>
          </Container.Content>
        </Container>
      </List>
    );
  }
}

class App extends Component {
  static contextType = PopupContext;

  constructor(props) {
    super(props);

    this.state = {};
  }

  render() {
    return (
      <Layout
        topLeft={
          <Welcome
            seam
            title="Welcome to your"
            subtitle="Dashboard"
            theme="light"
          />
        }
        topRight={
          <Row gap="20px">
            <Button className="button--proceed" onClick={() => window.location.href = `/mydmc/messages?new=true&admin_team=${window.default_admin_team_id}`}>Speak to us</Button>
            <Button className="button--save" onClick={() => window.location.href = '/mydmc/account/memberships'}>My Membership</Button>
          </Row>
        }
      >
        <SeventyThirtyLayout
          main={
            <Dashboard
              onboarding={this.props.onboarding}
              onboardingOwner={this.props.onboardingOwner}
            />
          }
          sectionOne={{
            name: "Side",
            component: (
              <Container>
                <Container.Header>
                  <Row gap="20px">
                    <Container.Icon src="/assets/icons/trophy.svg" />
                    <Container.Text
                      fontSize="18px"
                      fontWeight="500"
                      color="#FCFCFC"
                    >
                      Latest DMC Updates
                    </Container.Text>
                  </Row>
                </Container.Header>

                <Container.Content>
                  <LatestUpdates/>
                </Container.Content>
              </Container>
            ),
          }}
        />
      </Layout>
    );
  }
}

const el = document.getElementById("dashboard");

if (el) {
  ReactDOM.render(
    <App/>,
    el,
  );
}
